import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('alumni_token') || '',
    user: JSON.parse(localStorage.getItem('alumni_user') || '{}'),
    profile: JSON.parse(localStorage.getItem('alumni_profile') || 'null'),
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
      localStorage.setItem('alumni_token', token)
      localStorage.setItem('alumni_user', JSON.stringify(user))
    },
    SET_PROFILE(state, profile) {
      state.profile = profile
      localStorage.setItem('alumni_profile', JSON.stringify(profile))
    },
    LOGOUT(state) {
      state.token = ''
      state.user = {}
      state.profile = null
      localStorage.removeItem('alumni_token')
      localStorage.removeItem('alumni_user')
      localStorage.removeItem('alumni_profile')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userType: state => state.user.userType || '',
    userId: state => state.user.id,
    isAuditor: state => {
      return state.user.userType === 'DEPARTMENT' && state.profile && state.profile.roleType === 'AUDITOR'
    }
  }
})
